export const WORKSPACE_SEGMENT_CONFIG_KEY = "workspace.segment";

export const WorkspaceSegments = Object.freeze({
  Generic: "generic",
  PassengerTransport: "passenger_transport",
  AutoParts: "auto_parts",
});

export const ALL_WORKSPACE_SEGMENTS = Object.freeze(Object.values(WorkspaceSegments));

const SEGMENT_KEY_RE = /^[a-z][a-z0-9_]{0,47}$/;

export function normalizeWorkspaceSegment(raw) {
  const s = String(raw || "").trim().toLowerCase();
  if (SEGMENT_KEY_RE.test(s)) return s;
  return WorkspaceSegments.Generic;
}

